import React, { useEffect } from 'react';
import { Outlet } from 'react-router-dom';

import CLocalizedTextString from '../../components/CLocalizedTextString';
import { PageRoutes } from '../../enums/enums';
import { useAppDispatch } from '../../hooks/hooks';
import { addBreadcrumbTextReplacement, purgeBreadcrumbTextReplacementDictForOutlets } from '../../store/appSlice';

export default function UserManagementOutlet() {
  const dispatch = useAppDispatch();
  const userAccountsTitle = CLocalizedTextString('sidebar.userAccounts');

  useEffect(() => {
    dispatch(addBreadcrumbTextReplacement([PageRoutes.USERS_OUTLET, userAccountsTitle]));
    return () => {
      dispatch(purgeBreadcrumbTextReplacementDictForOutlets());
    };
  }, [dispatch, userAccountsTitle]);

  return <Outlet />;
}
